import { useQuery } from "@tanstack/react-query"

import { getMotibellLanding } from "lib/api/motibell/getMotibellLanding"

const useGetMotibellLanding = ({ motibellNo = 0 }, options) => {
  return useQuery(createKey(motibellNo), () => getMotibellLanding({ motibellNo }), {
    ...options,
  })
}

const createKey = (motibellNo) => ["motibell-landing", motibellNo]
useGetMotibellLanding.createKey = createKey

export default useGetMotibellLanding
